import React from 'react'
import { InsightsSummary } from '../../InsightsSummary'

interface MAAIInsightsTabProps {
  fixtureId: number
}

export function MAAIInsightsTab({ fixtureId }: MAAIInsightsTabProps) {
  return (
    <div>
      <InsightsSummary fixtureId={fixtureId} maxInsights={10} />
    </div>
  )
}
